import { db } from '../components/Dexie';

/**
 * Logs a message to the console and saves it to the Dexie database.
 * @param {string} message The main log message.
 * @param {string} [type='INFO'] The type of log (e.g., 'INFO', 'WARNING', 'ERROR').
 * @param {any} [details=null] Optional additional data to store with the log.
 */
export const log = async (message, type = 'INFO', details = null) => {
  const timestamp = new Date().toISOString();

  // 1. Print to console
  console.log(`[${type}] ${message}`, details || '');

  // 2. Save to DexieDB
  try {
    await db.logs.add({
      timestamp,
      type,
      message,
      details,
    });
  } catch (error) {
    console.error('Failed to save log to DexieDB:', error);
    // Fallback or further error handling
  }
};
